var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-icon"},[_c('md-icon',{staticClass:"text-info"},[_vm._v("info_outline")]),_c('md-tooltip',{attrs:{"md-direction":"bottom"}},[_vm._v("on bottom")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }